import React from 'react';

export default function LoadingSpinner({ text = 'Chargement...' }) {
  return (
    <div style={{ textAlign: 'center', padding: '3rem' }}>
      <div className="spinner" />
      {text && <p style={{ color: 'var(--muted)', marginTop: '0.5rem', fontSize: '0.9rem' }}>{text}</p>}
    </div>
  );
}
